"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GWEI_TO_WEI = void 0;
/** Easy conversion from Gwei to wei */
exports.GWEI_TO_WEI = BigInt(1000000000);
//# sourceMappingURL=units.js.map